/* eslint-disable react/forbid-prop-types */
/* eslint-disable react/prop-types */
/* eslint-disable no-unused-vars */
import React, { useState } from 'react';
import { Collapse } from 'reactstrap';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const SidebarCategory = ({
  title, icon, isNew, children, linkColor, linkReverseColor,
}) => {
  const [collaspe, setCollaspe] = useState(false);
  const [hover, sethover] = useState(false);

  const toggleHover = (opt) => {
    sethover(opt);
  };

  const categoryClass = classNames({
    'sidebar__category-wrap': true,
    'sidebar__category-wrap--open': collaspe,
  });

  const [childHover, setChildHover] = useState(false);
  const handleChildHover = (opt) => {
    setChildHover(opt);
  };
  return (
    <div className={categoryClass}>
      <button
        type="button"
        className="sidebar__link sidebar__category"
        style={{ display: 'flex', backgroundColor: hover ? linkColor : null }}
        onMouseEnter={() => toggleHover(true)}
        onMouseLeave={() => toggleHover(false)}
        onClick={() => setCollaspe(!collaspe)}
      >
        <div style={{ color: hover ? linkReverseColor : 'black' }}>
          {icon}
        </div>
        <p className="sidebar__link-title" style={{ margin: 0 }}>
          {title}
          {isNew && <span className="sidebar__category-new" />}
        </p>
        <span className="sidebar__category-icon lnr lnr-chevron-right" style={{ marginLeft: 'auto' }} />
      </button>
      <Collapse isOpen={collaspe}>
        <ul className="sidebar__submenu">
          <div style={{ marginLeft: 10 }}>
            {React.Children.map(children, (child) => (
              <div
                onMouseEnter={() => handleChildHover(true)}
                onMouseLeave={() => handleChildHover(false)}
                style={{
                }}
              >
                {child}
              </div>
            ))}
          </div>
        </ul>
      </Collapse>
    </div>
  );
};

SidebarCategory.propTypes = {
  title: PropTypes.string.isRequired,
  icon: PropTypes.any,
  isNew: PropTypes.bool,
  linkColor: PropTypes.string.isRequired,
  linkReverseColor: PropTypes.string.isRequired,
  children: PropTypes.arrayOf(PropTypes.element).isRequired,
};

SidebarCategory.defaultProps = {
  icon: '',
  isNew: false,
};

export default SidebarCategory;
